import { createSelector } from 'reselect';

const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector(
  [selectUser],
  (user) => user.currentUser ? user.currentUser : undefined
);

export const selectCurrentUserRol = createSelector(
  [selectUser],
  (user) => user.userRol ? user.userRol : undefined
);

export const selectCurrentUserNivel = createSelector(
  [selectUser],
  (user) => user.userNivel ? user.userNivel : undefined
);

export const selectAspirante = createSelector(
  [selectUser],
  (user) => user.datosAspirante ? user.datosAspirante : undefined
);

export const selectEstatusRegistro = createSelector(
  [selectAspirante],
  (datosAspirante) => datosAspirante ? datosAspirante.estatusRegistro : undefined
);

export const selectEstatusExito = createSelector(
  [selectUser],
  (user) => user.exito ? user.exito : undefined
);

export const selectEstadoDistritoAspirante = createSelector(
  [selectUser],
  (user) => user.estadoDistritoAspirante ? user.estadoDistritoAspirante : undefined
);

export const selectFechaHoraActividad = createSelector(
  [selectUser],
  (user) => user.fechaHoraActividad ? user.fechaHoraActividad : undefined
);